import { Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
// const key = 'AIzaSyBtVycyg60GqGGLN3BzWCFdfSnFIwTgNQ4';
// const key='AIzaSyBcQT4E1LrcaEFWYJDA4XRk0i6ykLNpBvc'
// const url = 'https://maps.googleapis.com/maps/api/js?libraries=places&key=' + key + '&callback=__onGoogleLoaded';
declare var window;
@Injectable()
export class mapsService {
  loadAPI: Promise<any>;
  url="";
  constructor(@Inject(PLATFORM_ID) private platformId: Object) {
    // if (isPlatformBrowser(this.platformId)) {
    //   this.loadAPI = new Promise((resolve) => {
    //     window['__onGoogleLoaded'] = (ev) => {
    //       resolve(window.gapi);
    //     };
    //     if (!window.google || !window.google.maps) {
    //       this.loadScript();
    //     }
    //   });
    // }
  }
  doSomethingGoogley(key) {
    this.url = 'https://maps.googleapis.com/maps/api/js?libraries=places&key=' + key + '&callback=__onGoogleLoaded';
    if (isPlatformBrowser(this.platformId)) {
      return new Promise((resolve) => {
        window['__onGoogleLoaded'] = (ev) => {
          resolve(window.gapi);
        };
        if (!window.google || !window.google.maps) {
          this.loadScript();
        }else{
          resolve(true)
        }
      });
    }
    return new Promise(r=>{});
  }
  loadScript() {
    if (isPlatformBrowser(this.platformId)) {
      const node = document.createElement('script');
      node.src = this.url;
      node.type = 'text/javascript';
      document.getElementsByTagName('head')[0].appendChild(node);
    }
  }
}
